import { render, staticRenderFns } from "./CoverThirdParty.vue?vue&type=template&id=32ad8b40&"
import script from "./CoverThirdParty.vue?vue&type=script&lang=js&"
export * from "./CoverThirdParty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports